import WebComponent from "../../common/WebComponent";
import { createSubmitListener } from "../../common/submitListener";

export class CodeEingabe extends WebComponent {
  static get tagName() {
    return "code-eingabe";
  }

  connectedCallback() {
    const form = this.querySelector(".downloadcode-form");
    this.addListener(form, "submit", createSubmitListener(this.showDefaultError.bind(this)));
  }

  showDefaultError() {
    const errorMessage = this.querySelector(".errorMessage");
    errorMessage.querySelector(".errorMessageContent").innerText = errorMessage.getAttribute("data-default");
    errorMessage.classList.remove("hidden");
  }
}

if (!customElements.get(CodeEingabe.tagName)) {
  customElements.define(CodeEingabe.tagName, CodeEingabe);
}